import { UntypedFormArray, UntypedFormGroup, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import * as _ from 'lodash';

export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  options: any = {};

  generate(entity: any, options) {
    this.options = { ...options, ...entity };
    let documentsForm: UntypedFormGroup[] = [];
    const documents = entity?.documents;

    if (documents)
      _.forEach(documents, (document, i: number) =>
        documentsForm.push(
          this.formBuilder.group(this.createModel(document, i)),
        ),
      );

    return this.formBuilder.group({
      documentsForm: this.formBuilder.array(
        documentsForm,
        Validators.nullValidator,
      ),
    });
  }

  get documentsForm() {
    const array = this.form.get('documentsForm') as UntypedFormArray;

    return array;
  }
  public createModel(item, index) {
    let model = {
      gedId: [item.gedId || null],
      prGedId: [item.prGedId || null],
      productId: [item?.productId || null],
      index: [item ? item.index : null],
      name: [item ? item.name : null],
      signatures: [item ? item.signatures : null],
      universignCheckBoxes: [item ? item.universignCheckBoxes : null],
      check: [
        {
          value: item?.signatures?.length ? 'print' : null,
          disabled: item?.signatures?.length ? false : true,
        },
      ],
      documentType: [item?.documentType || null],
    };
    return model;
  }

  extract() {
    return this.form.value;
  }
}
